"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "FlexItem", {
  enumerable: true,
  get: function get() {
    return _FlexItem.default;
  }
});

exports.default = exports.spacingOptions = exports.flexDirectionOptions = exports.justifyOptions = exports.alignments = exports.alignContentOptions = exports.wrapOptions = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

require("../../util/GlobalScript.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _Padding = require("../layout/Padding");

var _FlexItem = _interopRequireDefault(require("./FlexItem"));

/**
 * @enum {string}
 * @alias FlexRow.wrapOptions
 */
var wrapOptions = {
  WRAP: "wrap",
  NOWRAP: "no-wrap",
  REVERSE: "reverse"
};
/**
 * @enum {string}
 * @alias FlexRow.alignContentOptions
 */

exports.wrapOptions = wrapOptions;
var alignContentOptions = {
  BOTTOM: "bottom",
  TOP: "TOP",
  CENTER: "CENTER",
  STRETCH: "STRETCH"
};
/**
 * @enum {string}
 * @alias FlexRow.alignments
 */

exports.alignContentOptions = alignContentOptions;
var alignments = {
  BOTTOM: "bottom",
  TOP: "TOP",
  CENTER: "CENTER",
  STRETCH: "STRETCH"
};
/**
 * @enum {string}
 * @alias FlexRow.justifyOptions
 */

exports.alignments = alignments;
var justifyOptions = {
  /** center */
  CENTER: "center",

  /** end */
  END: "end",

  /** spacebetween */
  SPACEBETWEEN: "spacebetween",

  /** spaceevenly */
  SPACEEVENLY: "spaceevenly",

  /** start */
  START: "start"
};
/**
 * @enum {string}
 * @alias FlexRow.flexDirectionOptions
 */

exports.justifyOptions = justifyOptions;
var flexDirectionOptions = {
  /** row */
  ROW: "row",

  /** row-reverse */
  ROWREVERSE: "row-reverse",

  /** column */
  COLUMN: "column",

  /** column-reverse */
  COLUMNREVERSE: "column-reverse"
};
/**
 * @class FlexRow
 * @desc A row for wrapping components in a flexbox container
 *
 * @param {string} [data-id="flex-row"]
 *      To define the base "data-id" value for the top-level HTML container.
 * @param {string} [className]
 *      A class name to be applied to the row.
 * @param {FlexRow.alignments} [alignment=alignments.BOTTOM]
 *      The vertical alignment of the items.
 * @param {boolean} [inline=false]
 *      If true, makes the FlexRow inline.
 * @param {FlexRow.justifyOptions} [justify=justifyOptions.START]
 *      The horizontal justification of the items.
 * @param {FlexRow.wrap} [wrap=wrapOptions.NOWRAP]
 *      How to wrap the items.
 * @param {Spacing.Sizes} [spacing]
 *      If supplied, with add spacing in between items.
 * @example
<FlexRow>
    <Button label="Button" noSpacing />
    <Button label="Another button" noSpacing />
    <Button
        inline
        label="Inline button"
        noSpacing
        type="primary"
    />
</FlexRow>
 */

exports.flexDirectionOptions = flexDirectionOptions;
var spacingOptions = _Padding.sizes;
exports.spacingOptions = spacingOptions;

var getWrapClass = function getWrapClass(wrap) {
  switch (wrap) {
    case wrapOptions.WRAP:
      return "flex-row--wrap-wrap";

    case wrapOptions.REVERSE:
      return "flex-row--wrap-reverse";

    case wrapOptions.NOWRAP:
    default:
      return "flex-row--wrap-nowrap";
  }
};

var getAlignmentClass = function getAlignmentClass(alignment) {
  switch (alignment) {
    case alignments.STRETCH:
      return "flex-row--align-stretch";

    case alignments.CENTER:
      return "flex-row--align-center";

    case alignments.TOP:
      return "flex-row--align-top";

    case alignments.BOTTOM:
    default:
      return "flex-row--align-bottom";
  }
};

var getContentClass = function getContentClass(content) {
  switch (content) {
    case alignContentOptions.STRETCH:
      return "flex-row--content-stretch";

    case alignContentOptions.CENTER:
      return "flex-row--content-center";

    case alignContentOptions.TOP:
      return "flex-row--content-top";

    case alignContentOptions.BOTTOM:
    default:
      return "";
  }
};

var getJustifyClass = function getJustifyClass(justify) {
  switch (justify) {
    case justifyOptions.CENTER:
      return "flex-row--justify-center";

    case justifyOptions.END:
      return "flex-row--justify-end";

    case justifyOptions.SPACEBETWEEN:
      return "flex-row--justify-between";

    case justifyOptions.SPACEEVENLY:
      return "flex-row--justify-evenly";

    case justifyOptions.START:
    default:
      return "flex-row--justify-start";
  }
};

var getFlexDirection = function getFlexDirection(flexDirection) {
  switch (flexDirection) {
    case flexDirectionOptions.ROW:
      return "flex-row--flex-direction-row";

    case flexDirectionOptions.ROWREVERSE:
      return "flex-row--flex-direction-row-reverse";

    case flexDirectionOptions.COLUMN:
      return "flex-row--flex-direction-column";

    case flexDirectionOptions.COLUMNREVERSE:
      return "flex-row--flex-direction-column-reverse";
  }
};

var FlexRow = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _context, _classnames;

  var alignment = _ref.alignment,
      children = _ref.children,
      className = _ref.className,
      alignContent = _ref.alignContent,
      dataId = _ref["data-id"],
      flexDirection = _ref.flexDirection,
      inline = _ref.inline,
      justify = _ref.justify,
      wrap = _ref.wrap,
      spacing = _ref.spacing,
      props = (0, _objectWithoutProperties2.default)(_ref, ["alignment", "children", "className", "alignContent", "data-id", "flexDirection", "inline", "justify", "wrap", "spacing"]);
  var isColumn = flexDirection === flexDirectionOptions.COLUMN || flexDirection === flexDirectionOptions.COLUMNREVERSE;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: (0, _classnames2.default)("flex-row", className, getAlignmentClass(alignment), getJustifyClass(justify), getWrapClass(wrap), getFlexDirection(flexDirection), getContentClass(alignContent), (_classnames = {}, (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context = "flex-row--".concat(isColumn ? "column" : "row", "-spacing-")).call(_context, spacing), spacing !== undefined), (0, _defineProperty2.default)(_classnames, "flex-row--inline", inline), _classnames)),
    "data-id": dataId,
    ref: ref
  }), children);
});
FlexRow.propTypes = {
  alignment: _propTypes.default.oneOf((0, _values.default)(alignments)),
  alignContent: _propTypes.default.oneOf((0, _values.default)(alignContentOptions)),
  "data-id": _propTypes.default.string,
  flexDirection: _propTypes.default.oneOf((0, _values.default)(flexDirectionOptions)),
  inline: _propTypes.default.bool,
  justify: _propTypes.default.oneOf((0, _values.default)(justifyOptions)),
  onMouseLeave: _propTypes.default.func,
  spacing: _propTypes.default.oneOf((0, _values.default)(spacingOptions)),
  wrap: _propTypes.default.oneOf((0, _values.default)(wrapOptions))
};
FlexRow.defaultProps = {
  alignment: alignments.BOTTOM,
  "data-id": "flex-row",
  inline: false,
  justify: justifyOptions.START,
  wrap: wrapOptions.NOWRAP
};
var _default = FlexRow;
exports.default = _default;